export default "__VITE_ASSET__CWkURFwS__"